import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLtLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M28.786 38.414 14.372 24 28.786 9.587l2.121 2.121L18.615 24l12.292 12.293z" }) }) })
});
export default SvgArrowLtLeft;
